import { StreamSplitType } from "./StreamSplitType";

export class StreamSplitTypeFunctions {
    public static streamSplitTypeIcon: (functionalityType: StreamSplitType) => string = (
        streamSplitType: StreamSplitType,
    ) => {
        switch (streamSplitType) {
            case StreamSplitType.NoSplit:
                return "ir-no-split";
            case StreamSplitType.TopHorisontalSplit:
                return "ir-top-horisontal-split";
            case StreamSplitType.BottomHorisontalSplit:
                return "ir-bottom-horisontal-split";
            case StreamSplitType.LeftVerticalSplit:
                return "ir-left-vertical-split";
            case StreamSplitType.RightVerticalSplit:
                return "ir-right-vertical-split";
            case StreamSplitType.TopLeftSplit:
                return "ir-top-left-split";
            case StreamSplitType.TopRightSplit:
                return "ir-top-right-split";
            case StreamSplitType.BottomLeftSplit:
                return "ir-bottom-left-split";
            case StreamSplitType.BottomRightSplit:
                return "ir-bottom-right-split";
            default:
                return "ir-no-split";
        }
    };
}
